export default "__VITE_ASSET__310bac78__"